import { gql } from '@apollo/client';

export const AscContributorProjectAllocationFragment = gql`
  fragment AscContributorProjectAllocation on AscContributorProjectAllocation {
    id
    ascProjectId
    contributorId
    allocationPercentAvg
    ascProjectName
    capitalizationStatus
    capitalizationStartDate
    capitalizationEndDate
    clusterType
  }
`;
